<template>
  <div>
    <v-row>
      <v-col class="mb-0 pb-0" cols="4">
        <label class="detail-title">URLs*</label>
        <v-text-field v-model="url" class="mb-0" outlined prefix="https://" hide-details>
          <template v-slot:append-outer>
            <mf-icon v-if="!loading" :disabled="!urlIsValid" color="primary" @click="addUrl(url)">add</mf-icon>
            <v-progress-circular v-else :size="24" indeterminate color="primary"></v-progress-circular>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="mb-0 py-0">
        <v-chip-group show-arrows active-class="primary--text">
          <v-chip
            v-for="(url, index) in internalValue"
            :key="index"
            v-clipboard="() => url"
            close
            :ripple="false"
            class="copy-button"
            @click:close="removeUrl(index)"
            @click="() => $snackbar({ message: 'Copiado para área de transferencia.' })"
          >
            <span>{{ url }}</span>
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { cloneDeep } from 'lodash'
import { QUERY_URL_IS_AVAILABLE } from '@/modules/configuracoes-admin/graphql'
export default {
  props: {
    value: Array,
  },
  data: () => ({
    lazyValue: [],
    url: '',
    loading: false,
  }),
  computed: {
    internalValue: {
      get() {
        return this.lazyValue
      },
      set(value) {
        this.lazyValue = value
        this.$emit('input', value)
      },
    },
    urlIsValid() {
      return /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/i.test(this.url) && !this.internalValue.includes(this.url)
    },
  },
  mounted() {
    this.lazyValue = this.value
  },
  methods: {
    removeUrl(index) {
      const urls = cloneDeep(this.internalValue)
      urls.splice(index, 1)
      this.internalValue = urls
    },
    async addUrl(url) {
      let result
      this.loading = true
      try {
        result = await this.$apollo.query({
          query: QUERY_URL_IS_AVAILABLE,
          fetchPolicy: 'network-only',
          variables: {
            url,
          },
        })
      } catch (e) {
        this.$snackbar({ message: 'Falha ao validar URL.' })
        this.loading = false
        return
      }
      this.url = ''
      this.loading = false
      if (result.data.urlIsAvailable) {
        const urls = cloneDeep(this.internalValue)
        urls.push(url)
        this.internalValue = urls
        Swal.fire({
          text: 'URL disponível',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
        })
      } else {
        Swal.fire({
          text: 'URL indisponível',
          icon: 'error',
        })
      }
    },
  },
}
</script>
